import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
    UnpublishedParentsDialogOutput,
    UnpublishedParentsValidity
} from '@common/entities/dialog/unpublished-parents-dialog.entity';

import {
    ActionItem,
    ActionItemStyle,
    ApiFragment,
    BaseContainer,
    DialogConfig,
    DialogRef
} from '@stylehaven/components';
@Component({
    standalone: false,
    selector: 'mhv-unpublished-parents-dialog',
    templateUrl: './unpublished-parents-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnpublishedParentsDialogComponent extends BaseContainer implements OnInit {
    public warningMsg: string;
    public validityObjects: UnpublishedParentsValidity[];

    constructor(public config: DialogConfig, public dialog: DialogRef<UnpublishedParentsDialogOutput>) {
        super();
    }

    ngOnInit(): void {
        this.initValidityObjects();
    }

    private initValidityObjects(): void {
        this.warningMsg = this.translateService.translate(`items.unpublished-parent-dialog.warning`);

        const children: ApiFragment[] = this.config.data.children;
        const unpublishedParents: ApiFragment[] = this.config.data.unpublishedParents;

        this.validityObjects = this.generateValidityObjects(children, unpublishedParents);
    }

    private generateValidityObjects(
        children: ApiFragment[],
        unpublishedParents: ApiFragment[]
    ): UnpublishedParentsValidity[] {
        return children.map((child: ApiFragment) => {
            let parent: ApiFragment | undefined = undefined;

            if (child.hasParent()) {
                parent = unpublishedParents.find(
                    (parent: ApiFragment) => parent.getRecordId() === child.getParentRecordId()
                );
            } else if (child.isCandidateChild()) {
                parent = unpublishedParents.find(
                    (parent: ApiFragment) => parent.getFragmentId() === child.getCandidateParentId()
                );
            }

            const message: string = this.translateService.translate(`items.unpublished-parent-dialog.message`, {
                title: child.getTitle()
            });

            if (!parent) {
                console.error(
                    `UnpublishedParentsDialogComponent: Parent for object with id ${child.getRecordId()} was not found. Possibly the user has no access to this object.`
                );
            }

            return {
                message,
                link: this.getUnpublishedParentLink(parent)
            };
        });
    }

    private getUnpublishedParentLink(parent: ApiFragment | undefined): ActionItem | null {
        if (!parent) {
            return null;
        }

        return {
            label: this.translateService.translate(`items.unpublished-parent-dialog.view-parent`),
            style: ActionItemStyle.Link,
            navigationLink: {
                route: parent.getDefaultUrl(),
                target: '_blank'
            }
        };
    }

    public cancel(): void {
        const output: UnpublishedParentsDialogOutput = { type: 'cancel' };
        this.dialog.close(output);
    }
}
